import {inject, Injectable} from "@angular/core";
import {GenerateDocumentRequest, ReportApiService, TaskInfoIdResponse} from "../../../deal/generated-sources/api/report";
import {Observable} from "rxjs";
import {TemplateContext, TemplateInfo} from "../../model/template-info";

@Injectable({
    providedIn: "root"
})
export class ReportService {
    private readonly reportApi = inject(ReportApiService);

    constructor( ) {
    }

    getTemplates(context: TemplateContext): Observable<TemplateInfo[]> {
        return this.reportApi.getTemplates(context);
    }

    generateDocument(templateInfo: TemplateInfo, returnUrl: string): Observable<TaskInfoIdResponse> {
        const request: GenerateDocumentRequest = {templateInfo, returnUrl};
        return this.reportApi.generateDocument(request);
    }

}
